import React, { Component } from 'react'

import { UNLOCK_WALLET_NAV } from '../constants/navigation'

export default (ChildComponent) => {
  class ComposedComponent extends Component {

    componentDidMount() {
      const { unlocked, history, location } = this.props
      if (!unlocked) {
        history.push({
          pathname: UNLOCK_WALLET_NAV,
          state: {
            from: location.pathname
          }
        })
      } else {
        this.props.lockWallet()
      }
    }

    render() {
      return (
        <ChildComponent {...this.props} />
      )
    }
  }

  return ComposedComponent
}


// WEBPACK FOOTER //
// ./src/hoc/requireUnlocked.js